var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "l-bg-white row leads-edit" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-9 col-lg-9 col-xl-9 leads-edit-wrap" },
          [
            !_vm.lead.ref_id
              ? [_c("content-loader")]
              : [
                  _c("div", { staticClass: "row bg-grey py-2 header-edit" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-7 col-md-11 col-lg-11 col-xl-11 header-edit-left"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "row align-items-center header-edit-left-content"
                          },
                          [
                            _c("button", {
                              staticClass:
                                "btn btn-back d-block d-xl-none d-md-none d-lg-none",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.$router.push("/leads")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-9 col-md-4 col-lg-4 col-xl-4 flex flex-column flex-lg-row flex-xl-row flex-md-row lead-status"
                              },
                              [
                                _c("button", {
                                  staticClass:
                                    "btn btn-back d-none d-xl-block d-md-block d-lg-block",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.$router.push("/leads")
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column mr-md-1 mr-lg-1 mr-xl-1"
                                  },
                                  [
                                    _c("span", { staticClass: "refId" }, [
                                      _vm._v(_vm._s(_vm.lead.ref_id))
                                    ]),
                                    _vm._v(" "),
                                    _vm.$_can("leads.source.update") &&
                                    _vm.sources
                                      ? _c(
                                          "div",
                                          [
                                            _c("simple-select", {
                                              staticClass:
                                                "small-simple-select",
                                              attrs: {
                                                options: _vm.sources,
                                                searchable: false,
                                                "hide-select": true,
                                                placeholder: "Select Source"
                                              },
                                              on: { input: _vm.setSource },
                                              model: {
                                                value: _vm.lead.source_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.lead,
                                                    "source_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "lead.source_id"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "label",
                                          {
                                            staticClass:
                                              "d-none d-md-block d-lg-block d-xl-block header-source ml-0"
                                          },
                                          [_vm._v(_vm._s(_vm.lead.source.name))]
                                        )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.lead.status
                                  ? [
                                      _c("div", [
                                        _vm.lead.status_id === 1
                                          ? _c(
                                              "span",
                                              {
                                                class: "btn-status btn-active"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.lead.status.name)
                                                )
                                              ]
                                            )
                                          : _vm.lead.status_id === 2
                                            ? _c(
                                                "span",
                                                {
                                                  class: "btn-status btn-booked"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.lead.status.name)
                                                  )
                                                ]
                                              )
                                            : _vm.lead.status_id === 3 ||
                                              _vm.lead.status_id === 6
                                              ? _c(
                                                  "span",
                                                  {
                                                    class:
                                                      "btn-status btn-closed"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.lead.status.name
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm.lead.status_id === 4 ||
                                                _vm.lead.status_id === 8
                                                ? _c(
                                                    "span",
                                                    {
                                                      class:
                                                        "btn-status btn-ncover"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.lead.status.name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm.lead.status_id === 5
                                                  ? _c(
                                                      "span",
                                                      {
                                                        class:
                                                          "btn-status btn-rtbook"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.lead.status.name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm.lead.status_id === 7
                                                    ? _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "btn-status btn-rejected"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.lead.status
                                                                .name
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "btn-status btn-active"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.lead.status
                                                                .name
                                                            )
                                                          )
                                                        ]
                                                      )
                                      ])
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 d-none d-md-block d-lg-block d-xl-block border-right text-right"
                              },
                              [
                                _c("label", [_vm._v("Booking price:")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-text" }, [
                                  _vm._v("$ " + _vm._s(_vm.lead.booked_price))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 d-none d-md-block d-lg-block d-xl-block border-right text-center px-1"
                              },
                              [
                                _c("label", [_vm._v("Min.")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-text" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.lead.company.minimum_hours
                                          ? _vm.lead.company.minimum_hours + "h"
                                          : "Not set"
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-2 d-none d-md-block d-lg-block d-xl-block border-right"
                              },
                              [
                                _c("label", [_vm._v("Moving Company:")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-text" }, [
                                  _vm._v(_vm._s(_vm.lead.company.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.$_can("leads.assign")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-2 d-none d-md-block d-lg-block d-xl-block border-right"
                                  },
                                  [
                                    _c("label", [_vm._v("Lead created by:")]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "info-text" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.lead.created_by &&
                                            _vm.lead.created_by.username
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$_can("leads.assign")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-2 d-none d-md-block d-lg-block d-xl-block"
                                  },
                                  [
                                    _c("label", [_vm._v("Assigned:")]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "info-text" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.lead.cluster_user &&
                                            _vm.lead.cluster_user.username
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-5 col-md-1 col-lg-1 col-xl-1 pl-md-1 pl-lg-1 pl-xl-1"
                      },
                      [
                        _vm.isActive()
                          ? _c("div", { staticClass: "float-right" }, [
                              _c(
                                "div",
                                { staticClass: "dropdown dropdown-menu-right" },
                                [
                                  _vm.lead.status_id !== 3 ||
                                  (_vm.lead.status_id === 3 &&
                                    (_vm.$_can(
                                      "leads.status.to_active_from_close"
                                    ) ||
                                      _vm.$_can("leads.no-availability.set")))
                                    ? _c("button", {
                                        staticClass:
                                          "btn btn-secondary add-filter",
                                        attrs: {
                                          type: "button",
                                          id: "dropdownMenuButton",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _vm.lead.status_id === 8 ||
                                      _vm.lead.status_id === 10
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function($event) {
                                                  _vm.changeStatus(
                                                    _vm.lead.id,
                                                    1
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Revert to Active\n                  "
                                              )
                                            ]
                                          )
                                        : _c("span", [
                                            _vm.lead.status_id === 1 ||
                                            _vm.lead.status_id === 7
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          5
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Ready for booking\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$_can("leads.update") &&
                                            _vm.lead.status_id !== 3
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showDepositModal = true
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Change deposit\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.lead.status_id !== 7 &&
                                            _vm.lead.status_id !== 3
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          7
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      On Hold\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$_can(
                                              "leads.set-final-follow-up"
                                            ) && _vm.lead.status_id !== 10
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          10
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Final follow up\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.lead.status_id !== 3
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          3
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Close lead\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$_can(
                                              "leads.no-availability.set"
                                            ) && _vm.lead.status_id !== 8
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          8
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      No availability\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$_can(
                                              "leads.status.to_active_from_close"
                                            ) && _vm.lead.status_id === 3
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          1
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Back to active\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$_can("leads.assign") &&
                                            _vm.lead.status_id !== 3
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: _vm.reassignModal
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Reassign lead\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.lead.company.use_mod_booking &&
                                            _vm.hasAvailability &&
                                            _vm.lead.status_id !== 3
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showBookingLinkModal = true
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Send booking link\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row py-3 mb-3 header-edit" },
                    [
                      _vm.lead.status.name !== "Booked" && !_vm.hasAvailability
                        ? _c("div", { staticClass: "col-md-12 mt-3" }, [
                            _vm.lead.addresses.length === 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-4 alert alert-warning text-center"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle mail-warning-icon"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "acknowledge-msg" },
                                      [
                                        _vm._v(
                                          "Company doesn't have availability on mod24.com"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-4 alert alert-warning text-center"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle mail-warning-icon"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "acknowledge-msg" },
                                      [
                                        _vm._v(
                                          "Company availability on mod24.com cannot be checked without both pickup and delivery ZIP"
                                        )
                                      ]
                                    )
                                  ]
                                )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lead.customer
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-lg-11 col-xl-11 col-md-11 pr-0 customer-info-wrapper"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-background position-relative flex-column flex-lg-row flex-xl-row flex-md-row"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-xl-2 col-lg-2 col-md-2 customer-name"
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "pointer",
                                          on: {
                                            click: function($event) {
                                              _vm.isActive() &&
                                                (_vm.showCustomerModal = !_vm.showCustomerModal)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.lead.customer.first_name
                                              ) +
                                              "\n                  " +
                                              _vm._s(
                                                _vm.lead.customer.last_name
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-md-9 col-lg-9 col-xl-9 d-flex flex-column d-lg-block d-xl-block d-md-block customer-info-content"
                                    },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "mr-4 header-icon" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "mod-icon-edit mod-icon-phone",
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.lead.customer.phone
                                                  ? _vm.phoneMask.maskedPhone(
                                                      _vm.lead.customer.phone
                                                    )
                                                  : "No phone added"
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "mr-4 header-icon" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "mod-icon-edit mod-icon-email",
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.lead.customer.email) +
                                              "\n                  "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.contactEmails(),
                                                  expression: "contactEmails()"
                                                }
                                              ],
                                              staticClass:
                                                "btn-status btn-active"
                                            },
                                            [
                                              _vm._v(
                                                "+" +
                                                  _vm._s(_vm.contactEmails())
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.lead.customer.customer_cards &&
                                      _vm.lead.customer.customer_cards.length
                                        ? _c(
                                            "small",
                                            { staticClass: "mr-4 header-icon" },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-edit mod-icon-cc",
                                                attrs: { "aria-hidden": "true" }
                                              }),
                                              _vm._v(
                                                "\n                  **** " +
                                                  _vm._s(
                                                    _vm.lead.customer.customer_cards.find(
                                                      function(c) {
                                                        return (
                                                          c.is_default === 1
                                                        )
                                                      }
                                                    ).card_number
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "small",
                                            { staticClass: "mr-4 header-icon" },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-edit mod-icon-cc"
                                              }),
                                              _vm._v(
                                                "\n                  No credit card added\n                "
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-1 header-icon customer-edit text-right"
                                    },
                                    [
                                      _vm.isActive()
                                        ? _c("span", {
                                            staticClass: "fa fa-pencil pointer",
                                            on: {
                                              click: function($event) {
                                                _vm.showCustomerModal = !_vm.showCustomerModal
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "col-11 col-lg-11 col-xl-11 col-md-11 p-3"
                            },
                            [_vm._m(0)]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-12 col-lg-1 col-md-1 col-xl-1 pl-1"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary pull-right",
                              attrs: {
                                disabled:
                                  _vm.lead.status &&
                                  (_vm.lead.status.name === "Booked" ||
                                    _vm.lead.status.name === "Closed" ||
                                    _vm.lead.status.name ===
                                      "No Availability" ||
                                    _vm.lead.status.name ===
                                      "Final follow up") &&
                                  !_vm.lead.customer_note
                              },
                              on: {
                                click: function($event) {
                                  _vm.showModalCustomerNote = !_vm.showModalCustomerNote
                                }
                              }
                            },
                            [
                              _vm.lead.customer_note
                                ? [_vm._v("View note")]
                                : [_vm._v("Add note")],
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa text-secondary",
                                class: _vm.showModalCustomerNote
                                  ? "fa fa-caret-up"
                                  : "fa fa-caret-down",
                                attrs: { "aria-hidden": "true" }
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.showModalCustomerNote
                            ? _c("customer-note", {
                                attrs: {
                                  "customer-note": _vm.customerNote,
                                  model: "leads",
                                  "model-id": _vm.lead.id,
                                  "note-id": _vm.lead.customer_note
                                    ? _vm.lead.customer_note.id
                                    : null,
                                  "user-id": _vm.user.id,
                                  "status-name":
                                    _vm.lead.status && _vm.lead.status.name
                                },
                                on: {
                                  close: function($event) {
                                    _vm.showModalCustomerNote = false
                                  },
                                  ok: _vm.saveCustomerNote
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "customer" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 py-3" },
                        [
                          _c("HeavyItemsDisclaimer", {
                            attrs: {
                              "company-heavy-items-fee":
                                _vm.lead.company.heavy_items_fee,
                              editable: _vm.isActive(),
                              "has-heavy-items": _vm.lead.has_heavy_items,
                              "lead-id": _vm.lead.id,
                              "model-heavy-items-fee": _vm.lead.heavy_items_fee
                            },
                            on: { getLead: _vm.getLead }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$_can("tags.show")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-12 px-5 d-flex align-items-center justify-content-start flex-wrap mb-3 mt-3"
                            },
                            _vm._l(_vm.lead.company.tags, function(tag) {
                              return _c("tag-color", {
                                key: tag.id,
                                attrs: {
                                  color: tag.color.name,
                                  name: tag.name,
                                  "input-class": "mr-3"
                                }
                              })
                            })
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lead.booking_link && _vm.lead.booking_link.sent_at
                        ? _c("booking-link-sent", { attrs: { lead: _vm.lead } })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.lead.status.name === "Booked"
                    ? _c("div", { staticClass: "row booking-indicator" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "booking-indicator-wrap" },
                              [
                                _vm._m(1),
                                _vm._v(" "),
                                _vm.$_can("jobs.update") ||
                                _vm.$_can("jobs.view-own")
                                  ? _c(
                                      "div",
                                      { staticClass: "col-3 px-0 text-right" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to:
                                                "/jobs/edit/" + _vm.lead.job_id
                                            }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "d-none d-md-inline-block d-lg-inline-block d-xl-inline-block"
                                              },
                                              [_vm._v("Go to job")]
                                            ),
                                            _vm._v(" "),
                                            _c("button", {
                                              staticClass: "btn btn-forward",
                                              attrs: { type: "button" }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ],
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col lead-tabs" }, [
                _c("div", { staticClass: "mb-4 nav nav-tabs nav-fill" }, [
                  _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.overviewModalStep === 1 ? "active" : ""],
                      on: {
                        click: function($event) {
                          _vm.setOverviewModalStep(1)
                        }
                      }
                    },
                    [_vm._v("\n              Addresses\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.overviewModalStep === 2 ? "active" : ""],
                      on: { click: _vm.goToLocationDetails }
                    },
                    [_vm._v("\n              Location details\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.overviewModalStep === 3 ? "active" : ""],
                      on: {
                        click: function($event) {
                          _vm.setOverviewModalStep(3)
                        }
                      }
                    },
                    [_vm._v("\n              Rates\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.overviewModalStep === 5 ? "active" : ""],
                      on: {
                        click: function($event) {
                          _vm.setOverviewModalStep(5)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              Discounts & Expenses\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.overviewModalStep === 6 ? "active" : ""],
                      on: {
                        click: function($event) {
                          _vm.setOverviewModalStep(6)
                        }
                      }
                    },
                    [_vm._v("\n              Fees & Percentages\n            ")]
                  ),
                  _vm._v(" "),
                  _vm.$_can("leads.logs.index")
                    ? _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [_vm.overviewModalStep === 4 ? "active" : ""],
                          on: {
                            click: function($event) {
                              _vm.setOverviewModalStep(4)
                            }
                          }
                        },
                        [_vm._v("\n              Log\n            ")]
                      )
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: { autocomplete: "no" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.save($event)
                  },
                  keydown: function($event) {
                    _vm.clearError($event)
                  }
                }
              },
              [
                _c("div", { attrs: { id: "accordion-wrap" } }, [
                  _c("div", { staticClass: "mobile-accordion" }, [
                    _c(
                      "div",
                      {
                        ref: "addresses",
                        staticClass: "card-header",
                        attrs: {
                          id: "headingOne",
                          "data-toggle": "collapse",
                          "data-target": "#collapseOne",
                          "aria-expanded": "true",
                          "aria-controls": "collapseOne"
                        },
                        on: {
                          click: function($event) {
                            _vm.setOverviewModalStep(1)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "mb-0" }, [
                          _vm._v("\n                Addresses\n              ")
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "chevron-alt",
                          class: { rotate: _vm.expanded.includes(1) },
                          attrs: {
                            src: require("../../assets/img/chevron-alt.svg"),
                            alt: "chevron"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "collapse",
                        class: { show: _vm.overviewModalStep === 1 },
                        attrs: {
                          id: "collapseOne",
                          "aria-labelledby": "headingOne",
                          "data-parent": "#accordion-wrap"
                        }
                      },
                      [
                        _c("section", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row mb-4 mt-2 mt-md-0 mt-lg-0 mt-xl-0"
                            },
                            [
                              _c("jobs-leads-addresses", {
                                attrs: {
                                  data: _vm.lead,
                                  "show-dropdown": _vm.showDropdown,
                                  permission: "leads.route.update",
                                  errors: _vm.errors
                                },
                                on: {
                                  toggleEditField: _vm.toggleEditField,
                                  setAddress: _vm.setAddress,
                                  switchRoute: _vm.switchRoute,
                                  addAddress: _vm.addAddress,
                                  removeAddress: _vm.removeAddress
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mobile-accordion" }, [
                    _c(
                      "div",
                      {
                        ref: "location",
                        staticClass: "card-header",
                        attrs: {
                          id: "headingTwo",
                          "data-toggle": "collapse",
                          "data-target": "#collapseTwo",
                          "aria-expanded": "true",
                          "aria-controls": "collapseTwo"
                        },
                        on: { click: _vm.goToLocationDetails }
                      },
                      [
                        _c("span", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n                Location details\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "chevron-alt",
                          class: { rotate: _vm.expanded.includes(2) },
                          attrs: {
                            src: require("../../assets/img/chevron-alt.svg"),
                            alt: "chevron"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "collapse",
                        class: { show: _vm.overviewModalStep === 2 },
                        attrs: {
                          id: "collapseTwo",
                          "aria-labelledby": "headingTwo",
                          "data-parent": "#accordion-wrap"
                        }
                      },
                      [
                        _c("section", [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "map-wrapper col-lg-5 col-xl-6 pr-0"
                              },
                              [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.mapLoading,
                                      expression: "!mapLoading"
                                    }
                                  ],
                                  staticStyle: {
                                    width: "480px",
                                    height: "500px"
                                  },
                                  attrs: { id: "mapid" }
                                }),
                                _vm._v(" "),
                                _vm.mapLoading
                                  ? _c("div", { staticClass: "loader-circle" })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "distance-wrapper col-lg-7 col-xl-6 mt-4 mt-lg-0 mt-md-0 mt-xl-0"
                              },
                              [
                                _vm.lead && _vm.lead.distances
                                  ? _c("Distance", {
                                      attrs: { distance: _vm.lead.distances }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "collapse",
                        class: { show: _vm.overviewModalStep === 5 },
                        attrs: {
                          id: "collapseFive",
                          "aria-labelledby": "headingFive",
                          "data-parent": "#accordion-wrap"
                        }
                      },
                      [
                        _c("section", [
                          _vm.overviewModalStep === 5
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-6" },
                                  [
                                    _c("LeadDiscounts", {
                                      attrs: { lead: _vm.lead }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-6" },
                                  [
                                    _c("LeadExpenses", {
                                      attrs: { lead: _vm.lead }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mobile-accordion" }, [
                    _c(
                      "div",
                      {
                        ref: "movers",
                        staticClass: "card-header",
                        attrs: {
                          id: "headingThree",
                          "data-toggle": "collapse",
                          "data-target": "#collapseThree",
                          "aria-expanded": "true",
                          "aria-controls": "collapseThree"
                        },
                        on: {
                          click: function($event) {
                            _vm.setOverviewModalStep(3)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "mb-0" }, [
                          _vm._v("\n                Rates\n              ")
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "chevron-alt",
                          class: { rotate: _vm.expanded.includes(3) },
                          attrs: {
                            src: require("../../assets/img/chevron-alt.svg"),
                            alt: "chevron"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "collapse",
                        class: { show: _vm.overviewModalStep === 3 },
                        attrs: {
                          id: "collapseThree",
                          "aria-labelledby": "headingThree",
                          "data-parent": "#accordion-wrap"
                        }
                      },
                      [
                        _c(
                          "section",
                          [
                            _c("div", { staticClass: "row my-3 lead-rates" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2 mb-3"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move date")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "form-control",
                                        staticStyle: { visibility: "hidden" },
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select date",
                                          red: "flatPickr",
                                          "data-input": ""
                                        },
                                        on: { "on-close": _vm.closedFlatPickr },
                                        model: {
                                          value: _vm.lead.move_date_new,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.lead,
                                              "move_date_new",
                                              $$v
                                            )
                                          },
                                          expression: "lead.move_date_new"
                                        }
                                      }),
                                      _vm._v(" "),
                                      !_vm.lead.move_date_new
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.lead.move_date,
                                                expression: "lead.move_date"
                                              }
                                            ],
                                            staticClass:
                                              "form-control flatpickr-input-sec pointer select-date-input",
                                            attrs: {
                                              placeholder: "Select date",
                                              "data-toggle": "",
                                              disabled: !_vm.isActive()
                                            },
                                            domProps: {
                                              value: _vm.lead.move_date
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.lead,
                                                  "move_date",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.lead.move_date_new,
                                                expression: "lead.move_date_new"
                                              }
                                            ],
                                            staticClass:
                                              "form-control flatpickr-input-sec pointer select-date-input",
                                            attrs: {
                                              placeholder: "Select date",
                                              "data-toggle": "",
                                              disabled: !_vm.isActive()
                                            },
                                            domProps: {
                                              value: _vm.lead.move_date_new
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.lead,
                                                  "move_date_new",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("error-field", {
                                    attrs: {
                                      errors: _vm.errors,
                                      field: "move_date"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-lg-4 col-md-4 col-xl-4 px-lg-2 px-md-2 px-xl-2 mb-3 mb-xl-0 mb-lg-0 mb-md-0"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Arrival window")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.arrival_windows,
                                          label: "label",
                                          disabled: !_vm.isActive(),
                                          placeholder: "Select Arrival Window"
                                        },
                                        on: { input: _vm.callGetOffers },
                                        model: {
                                          value: _vm.lead.arrival_window_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.lead,
                                              "arrival_window_id",
                                              $$v
                                            )
                                          },
                                          expression: "lead.arrival_window_id"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("error-field", {
                                    attrs: {
                                      errors: _vm.errors,
                                      field: "arrival_window"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2 mb-3 mb-xl-0 mb-lg-0 mb-md-02"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move size")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.move_sizes,
                                          disabled: !_vm.isActive(),
                                          placeholder: "Select Move Sizes"
                                        },
                                        on: { input: _vm.callGetOffers },
                                        model: {
                                          value: _vm.lead.move_size_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.lead,
                                              "move_size_id",
                                              $$v
                                            )
                                          },
                                          expression: "lead.move_size_id"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("error-field", {
                                    attrs: {
                                      errors: _vm.errors,
                                      field: "move_size_id"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Movers")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.numberOfMovers,
                                          disabled: !_vm.isActive(),
                                          placeholder: "Number od Movers"
                                        },
                                        on: { input: _vm.callGetOffers },
                                        model: {
                                          value: _vm.lead.movers,
                                          callback: function($$v) {
                                            _vm.$set(_vm.lead, "movers", $$v)
                                          },
                                          expression: "lead.movers"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("error-field", {
                                    attrs: {
                                      errors: _vm.errors,
                                      field: "movers"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 col-lg-4 col-md-4 col-xl-4 pl-lg-2 pl-0 pl-md-2 pl-xl-2 pr-lg-2 pr-md-2 pr-xl-2"
                                },
                                [
                                  _c("div", { staticClass: "select-wrap" }, [
                                    _c("label", [_vm._v("Trucks")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.lead.trucks,
                                          expression: "lead.trucks"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        disabled: !_vm.isActive()
                                      },
                                      domProps: { value: _vm.lead.trucks },
                                      on: {
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.lead,
                                              "trucks",
                                              $event.target.value
                                            )
                                          },
                                          _vm.callGetOffers
                                        ]
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("error-field", {
                                    attrs: {
                                      errors: _vm.errors,
                                      field: "trucks"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("error-field", {
                                    attrs: {
                                      errors: _vm.errors,
                                      field: "truck_number"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 col-lg-2 col-md-2 col-xl-2 pr-lg-2 pr-md-2 pr-xl-2 price-info transaction-fee"
                                },
                                [
                                  _c("label", [_vm._v("Transaction fee")]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "m-0" }, [
                                    _vm._v(
                                      _vm._s(_vm.lead.company.charge_fee || 0) +
                                        "%"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.lead.company.cash_discount_value > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-6 col-lg-2 col-md-2 col-xl-2 pl-lg-2 pl-0 pl-md-2 pl-xl-2 price-info cash-discount"
                                    },
                                    [
                                      _c("label", [_vm._v("Cash Discount")]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "m-0" }, [
                                        _vm._v(
                                          _vm._s(_vm.lead.cash_discount_value) +
                                            _vm._s(
                                              _vm.lead.cash_discount_unit
                                            ) +
                                            " per hour"
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              staticClass: "my-3",
                              attrs: { errors: _vm.errors, field: "booking" }
                            }),
                            _vm._v(" "),
                            _vm.lead.status_id === 1 ||
                            _vm.lead.status_id === 5 ||
                            _vm.lead.status_id === 7
                              ? [
                                  _c("offer", {
                                    ref: "offerRef",
                                    attrs: {
                                      data: _vm.lead,
                                      "book-offer-prop": _vm.bookOffer,
                                      "loading-book-button":
                                        _vm.loadingBookButton,
                                      "button-disabled": _vm.buttonDisabled,
                                      "booking-phone":
                                        _vm.lead.company.booking_phone,
                                      "get-offers-on-load": true
                                    },
                                    on: {
                                      "set-offer-error": _vm.setOfferError,
                                      "offers-loaded": _vm.setHasAvailability
                                    }
                                  })
                                ]
                              : _vm.lead.status_id === 6
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "alert alert-warning" },
                                      [
                                        _vm._v(
                                          "\n                    Booking is currently disabled because the company is not active or setup wasn’t completed. Please\n                    contact your manager for further details.\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                            _vm._v(" "),
                            _vm.lead.company.booking_send_offers
                              ? _c("div", [
                                  _vm.lead.status_id === 1 ||
                                  _vm.lead.status_id === 5 ||
                                  _vm.lead.status_id === 7
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex align-items-end justify-content-end mt-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-column align-items-center justify-content-center mb-5"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-primary",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click:
                                                      _vm.sendLeadBookingEmail
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Send offer to customer\n                      "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c("customTooltip", {
                                                    attrs: {
                                                      config: {
                                                        placement: "top"
                                                      }
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var isOpen =
                                                            ref.isOpen
                                                          var open = ref.open
                                                          var close = ref.close
                                                          return _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                padding:
                                                                  "0 5px 0 5px"
                                                              },
                                                              on: {
                                                                mouseover: open,
                                                                mouseleave: close
                                                              }
                                                            },
                                                            [
                                                              _vm.lead
                                                                .offers_sent_diff
                                                                ? _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "lead-sent-offer-diff",
                                                                      attrs: {
                                                                        "data-trigger":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              Sent " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .lead
                                                                              .offers_sent_diff
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: isOpen,
                                                                      expression:
                                                                        "isOpen"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "custom-tooltip",
                                                                  attrs: {
                                                                    "data-popper":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm.lead
                                                                    .offers_sent
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "border-black",
                                                                          staticStyle: {
                                                                            color:
                                                                              "black"
                                                                          },
                                                                          attrs: {
                                                                            "x-arrow":
                                                                              ""
                                                                          }
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.lead
                                                                          .offers_sent
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      }
                                                    ])
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mobile-accordion" }, [
                    _c(
                      "div",
                      {
                        ref: "log",
                        staticClass: "card-header",
                        attrs: {
                          id: "headingFour",
                          "data-toggle": "collapse",
                          "data-target": "#collapseFour",
                          "aria-expanded": "true",
                          "aria-controls": "collapseFour"
                        },
                        on: {
                          click: function($event) {
                            _vm.setOverviewModalStep(4)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "mb-0" }, [
                          _vm._v("\n                Log\n              ")
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "chevron-alt",
                          class: { rotate: _vm.expanded.includes(4) },
                          attrs: {
                            src: require("../../assets/img/chevron-alt.svg"),
                            alt: "chevron"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.overviewModalStep === 4
                      ? _c(
                          "div",
                          {
                            staticClass: "collapse",
                            class: { show: _vm.overviewModalStep === 4 },
                            attrs: {
                              id: "collapseFour",
                              "aria-labelledby": "headingFour",
                              "data-parent": "#accordion-wrap"
                            }
                          },
                          [
                            _c("section", [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _vm.lead.id
                                      ? _c("log", {
                                          attrs: {
                                            model: _vm.lead,
                                            type: "leads"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mobile-accordion" }, [
                    _c(
                      "div",
                      {
                        ref: "fees-percentages",
                        staticClass: "card-header",
                        attrs: {
                          id: "headingSix",
                          "data-toggle": "collapse",
                          "data-target": "#collapseSix",
                          "aria-expanded": "true",
                          "aria-controls": "collapseSix"
                        },
                        on: {
                          click: function($event) {
                            _vm.setOverviewModalStep(6)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n                Fees & Percentages\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "chevron-alt",
                          class: { rotate: _vm.expanded.includes(6) },
                          attrs: {
                            src: require("../../assets/img/chevron-alt.svg"),
                            alt: "chevron"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.overviewModalStep === 6
                      ? _c(
                          "div",
                          {
                            staticClass: "collapse",
                            class: { show: _vm.overviewModalStep === 6 },
                            attrs: {
                              id: "collapseSix",
                              "aria-labelledby": "headingSix",
                              "data-parent": "#accordion-wrap"
                            }
                          },
                          [
                            _c("section", [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _c("FeesPercentages", {
                                      attrs: {
                                        "fee-change": _vm.lead.fee_change,
                                        "lead-id": _vm.lead.id,
                                        enabled: _vm.isActive()
                                      },
                                      on: {
                                        getLead: function($event) {
                                          _vm.$emit("getLead")
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm.editedField
                  ? _c(
                      "div",
                      { staticClass: "row mx-0 position-fixed hidden-buttons" },
                      [
                        _c("div", { staticClass: "col pb-2 pt-2 text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary ld-ext-right",
                              class: _vm.loadingDiscardButton ? "running" : "",
                              attrs: { type: "button" },
                              on: { click: _vm.discardLead }
                            },
                            [
                              _vm._v("\n              Discard\n              "),
                              _c("div", { staticClass: "ld ld-ball ld-flip" })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary ld-ext-right",
                              class: _vm.loadingButton ? "running" : "",
                              attrs: { disabled: _vm.buttonDisabled }
                            },
                            [
                              _vm._v("\n              Save\n              "),
                              _c("div", { staticClass: "ld ld-ball ld-flip" })
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-3 col-lg-3 col-xl-3 border-left" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 nav nav-tabs nav-fill p-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-6 nav-item nav-link pointer",
                    class: [
                      _vm.rightSidebarTab === "followups" ? "active" : ""
                    ],
                    on: {
                      click: function($event) {
                        _vm.rightSidebarTab = "followups"
                      }
                    }
                  },
                  [_vm._v("\n            Follow ups\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-6 nav-item nav-link pointer",
                    class: [_vm.rightSidebarTab === "notes" ? "active" : ""],
                    on: {
                      click: function($event) {
                        _vm.rightSidebarTab = "notes"
                      }
                    }
                  },
                  [_vm._v("\n            Comments\n          ")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row", staticStyle: { height: "95vh" } }, [
              _vm.rightSidebarTab === "followups"
                ? _c(
                    "div",
                    { staticClass: "w-100 follows-wrap" },
                    [
                      _vm.lead
                        ? _c("leads-followups", {
                            staticClass: "px-4",
                            attrs: { lead: _vm.lead },
                            on: { update: _vm.getLead }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.rightSidebarTab === "notes"
                ? _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "row notes-box pt-3" },
                      [
                        _vm._l(_vm.lead.notes, function(note) {
                          return _c(
                            "div",
                            {
                              key: note.id,
                              staticClass: "col-12 single-note pb-4"
                            },
                            [
                              typeof note.note === "string" &&
                              note.note.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "border rounded m-0 p-2" },
                                    [
                                      _c("strong", { staticClass: "d-block" }, [
                                        _vm._v(
                                          _vm._s(note.user.first_name) +
                                            " " +
                                            _vm._s(note.user.last_name)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v(_vm._s(note.note))]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "small" }, [
                                        _vm._v(_vm._s(note.date))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "row pt-2 px-2 mb-2 mx-0 fixed-bottom border-top position-absolute notes-field bg-white"
                          },
                          [
                            _c("div", { staticClass: "col-10 px-0" }, [
                              _vm.editNote
                                ? _c(
                                    "div",
                                    { staticClass: "border w-100 text-field" },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "auto-resize",
                                            rawName: "v-auto-resize"
                                          },
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.lead.note,
                                            expression: "lead.note"
                                          }
                                        ],
                                        domProps: { value: _vm.lead.note },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.lead,
                                              "note",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "border w-100 text-field" },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "auto-resize",
                                            rawName: "v-auto-resize"
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            _vm.editNote = true
                                          }
                                        }
                                      })
                                    ]
                                  )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-2 pointer px-0" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary pt-2",
                                  attrs: { disabled: _vm.editNote === false },
                                  on: { click: _vm.saveNote }
                                },
                                [_c("span", { staticClass: "mod-icon-note" })]
                              )
                            ])
                          ]
                        )
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCustomerModal
          ? _c(
              "div",
              { staticClass: "l-modal-mask" },
              [
                _vm.showCustomerModal
                  ? _c("side-modal-customer-info", {
                      attrs: { data: _vm.lead, "lead-id": _vm.lead.id },
                      on: {
                        cancel: function($event) {
                          _vm.showCustomerModal = false
                        },
                        update: _vm.getLead
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showReassignModal
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large", "close-strict": true },
              on: {
                close: function($event) {
                  _vm.showReassignModal = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-10" }, [
                    _c("div", [
                      _c("h4", [_vm._v("Select user to assign lead to")])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Select User")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: { options: _vm.assignees },
                        on: {
                          change: function($event) {
                            _vm.clearError($event)
                          }
                        },
                        model: {
                          value: _vm.assigneeId,
                          callback: function($$v) {
                            _vm.assigneeId = $$v
                          },
                          expression: "assigneeId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "cluster_user_id" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary pull-right",
                        attrs: { type: "button" },
                        on: { click: _vm.reassign }
                      },
                      [_vm._v("\n            Reassign\n          ")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showBookingLinkModal &&
      _vm.bookingLink &&
      _vm.lead.company.use_mod_booking
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large", "close-strict": false },
              on: {
                close: function($event) {
                  _vm.showBookingLinkModal = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-10" }, [
                    _c("div", [_c("h4", [_vm._v("Link to be sent")])])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { id: "booking-link", type: "text", readonly: "" },
                    domProps: { value: _vm.bookingLink }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "input-group-append pointer",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.copyToClipboard(
                            _vm.bookingLink,
                            "Successfully copied to clipboard"
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-text" }, [
                        _c("span", [
                          _c("i", { staticClass: "fa fa-copy list-box-icon" })
                        ])
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end w-100"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary pull-right mr-3",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.lead.company.phone_numbers &&
                            !_vm.lead.company.phone_numbers.find(function(num) {
                              return num.type.id === 1
                            })
                        },
                        on: {
                          click: function($event) {
                            _vm.openSendBookingLink("sms")
                          }
                        }
                      },
                      [_vm._v("\n          Send link SMS\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary pull-right",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.openSendBookingLink("email")
                          }
                        }
                      },
                      [_vm._v("\n          Send link email\n        ")]
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDepositModal
        ? _c(
            "modal",
            {
              attrs: { "close-strict": true },
              on: {
                close: function($event) {
                  _vm.showDepositModal = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-10" }, [
                    _c("div", [_c("h4", [_vm._v("Enter new deposit value")])])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-7" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Deposit")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lead.deposit_value,
                              expression: "lead.deposit_value"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            autocomplete: "no",
                            placeholder: "Enter Deposit",
                            disabled: !_vm.$_can("leads.update")
                          },
                          domProps: { value: _vm.lead.deposit_value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.lead,
                                "deposit_value",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "deposit_value" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Unit")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "simple-select" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "simple-select-header simple-select-header",
                            on: {
                              click: function($event) {
                                _vm.$_can("leads.update")
                                  ? (_vm.dropdownUnit = !_vm.dropdownUnit)
                                  : null
                              }
                            }
                          },
                          [
                            _c("input", {
                              staticClass: "simple-select-input",
                              attrs: {
                                placeholder: _vm.unitOptions.find(function(el) {
                                  return el.id === _vm.lead.deposit_unit
                                }).name,
                                disabled: !_vm.$_can("leads.update")
                              },
                              on: {
                                blur: function($event) {
                                  _vm.closeList()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "simple-select-caret" }, [
                              _c("i", { staticClass: "fa fa-caret-down" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.dropdownUnit
                          ? _c(
                              "div",
                              { staticClass: "simple-select-options" },
                              [
                                _c("ul", [
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "select-option select-option-boolean",
                                      staticStyle: { "pointer-events": "auto" },
                                      on: {
                                        click: function($event) {
                                          _vm.setDepositUnit("$")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "select-label" },
                                        [_vm._v("$")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "select-option select-option-boolean",
                                      staticStyle: { "pointer-events": "auto" },
                                      on: {
                                        click: function($event) {
                                          _vm.setDepositUnit("%")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "select-label" },
                                        [_vm._v("%")]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary pull-right",
                        attrs: { type: "button" },
                        on: { click: _vm.setDeposit }
                      },
                      [_vm._v("\n            Save\n          ")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalNewTransaction
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large" },
              on: {
                close: function($event) {
                  _vm.showModalNewTransaction = false
                },
                ok: _vm.createTransaction
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", { staticClass: "m-header-2" }, [
                  _vm._v("\n        New Transaction\n      ")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("div", { staticClass: "row l-m-b-16" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", { staticClass: "m-label" }, [
                          _vm._v("Payment type:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.transaction.payment_type_id,
                                expression: "transaction.payment_type_id"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { name: "type" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.transaction,
                                    "payment_type_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  _vm.errors.clear("payment_type_id")
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.paymentTypes, function(type) {
                            return _c(
                              "option",
                              { key: type.id, domProps: { value: type.id } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(type.name) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "payment_type_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", { staticClass: "m-label" }, [
                          _vm._v("Payment method:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.transaction.payment_method_id,
                                expression: "transaction.payment_method_id"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { name: "payment_type" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.transaction,
                                    "payment_method_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  _vm.errors.clear("type_id")
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.paymentMethods, function(method) {
                            return _c(
                              "option",
                              {
                                key: method.id,
                                domProps: { value: method.id }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(method.name) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "payment_method_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", { staticClass: "m-label" }, [
                          _vm._v("Price:")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.transaction.amount,
                              expression: "transaction.amount"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number", min: "0" },
                          domProps: { value: _vm.transaction.amount },
                          on: {
                            keydown: function($event) {
                              _vm.errors.clear("amount")
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.transaction,
                                "amount",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "amount" }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.transaction.payment_method_id === 4
                    ? _c("payment", {
                        attrs: {
                          customer: _vm.lead.customer,
                          company: _vm.lead.company,
                          width: "col-12"
                        },
                        on: { update: _vm.getLead }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", { staticClass: "m-label" }, [
                          _vm._v("Notes:")
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.transaction.note,
                              expression: "transaction.note"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { rows: "5" },
                          domProps: { value: _vm.transaction.note },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.transaction,
                                "note",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "note" }
                        }),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "ref_id" }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSendBookingLinkEmail
        ? _c("booking-link-email-modal", {
            attrs: { lead: _vm.lead },
            on: {
              close: function($event) {
                _vm.showSendBookingLinkEmail = false
              },
              load: _vm.getLead
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSendBookingLinkSMS
        ? _c("booking-link-s-m-s-modal", {
            attrs: { lead: _vm.lead },
            on: {
              close: function($event) {
                _vm.showSendBookingLinkSMS = false
              },
              load: _vm.getLead
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "px-3 py-1",
        staticStyle: { "background-color": "#f8d7d9" }
      },
      [_c("h6", [_vm._v("Deleted "), _c("br"), _vm._v(" Customer")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9 d-flex px-0" }, [
      _c("span", { staticClass: "fa fa-check" }),
      _vm._v(" "),
      _c("h3", [_vm._v("The lead has been booked!")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d813149", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d813149","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/LeadsEdit.vue
// module id = null
// module chunks = 